






























































































































































































































































































































// @ is an alias to /src
import Vue2Filters from "vue2-filters";

import Vue from "vue";
import { RouteRepo, IRoute, IRouteContent } from "../libs/RouteRepository";
import { Config } from "../libs/Config";
import VueGoogleAutocomplete from "../../node_modules/vue-google-autocomplete/src/VueGoogleAutocomplete.vue";
//@ts-ignore

import BasicAudioPlayer from "../components/BasicAudioPlayer";
import NoSleep from "nosleep.js";

//@ts-ignore
import { gmapApi } from "vue2-google-maps";
export default Vue.extend({
  name: "Home",
  components: {
    VueGoogleAutocomplete,
    BasicAudioPlayer,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      address: {
        formatted_address: "",
      } as any,
      viewMode : 'overview',
      routes: [] as IRoute[],
      imageHost: Config.ImageUrl,
      showLocationPopup: false,
      intro: undefined as IRouteContent | undefined,
      showIosPopup: false,
      searchAddress: false,
      showInstallPopup : false,
      alreadyAccepted : false,
      showPopup : true,
      deferredPrompt: null as any,
      locationMessage: "",
      currentStep: 0,
      currentPosition: undefined as any,
    };
  },
  methods: {
    isIos: function () {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(userAgent)) {
        return true;
      } else {
        return (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform)
        );
      }
    },
    async getInfo(routeId : string){
      var introContent =  await RouteRepo.getRouteIntroById(routeId);
      if(introContent != undefined){
        this.viewMode = "intro";
        this.intro =introContent;
      }
      
    },
    setViewMode :  function(viewMode: string){
      this.viewMode = viewMode;
    },
    hidePopup :  function(){
      this.showPopup = false;
    },
    hideInstall: function () {
      this.showIosPopup = false;
      localStorage.setItem("hideInstall", "1");
    },
    hideInstallSecond: function () {
      this.showInstallPopup = false;
      localStorage.setItem("hideInstall", "1");
    },
    installPwa : function() {
      var self = this;
            self.showInstallPopup = false;

      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt

      this.deferredPrompt.userChoice
        // @ts-ignore
        .then(choiceResult => {
          if (choiceResult.outcome === "accepted") {
            console.log("User accepted the A2HS prompt");
          } else {
            console.log("User dismissed the A2HS prompt");
          }


          self.deferredPrompt = null;
        });
    },
    async getRoutes() {
      this.routes = await RouteRepo.getRoutes(
        // @ts-ignore
        this.address.longitude,
        // @ts-ignore
        this.address.latitude
      );
      console.log(this.routes);
      for (let index = 0; index < this.routes.length; index++) {
        const element = this.routes[index];
        await this.validRoute(element.routeId);
      }
    },
    confirmLocation: function () {
      var self = this;
      localStorage.setItem("location", "1");
      this.showLocationPopup = false;
      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            self.currentPosition = position;
            localStorage.setItem("location", "1");
            self.showLocationPopup = false;
            console.log(position);
            // @ts-ignore
            self.address.longitude = position.coords.longitude;
            // @ts-ignore
            self.address.latitude = position.coords.latitude;
            self.getRoutes();
            // @ts-ignore
            var geocoder = new google.maps.Geocoder();
            // @ts-ignore
            var myLatlng = new google.maps.LatLng(parseFloat(position.coords.latitude), parseFloat(position.coords.longitude));
            geocoder.geocode({ location: myLatlng }, function (
              results: any,
              status: any
            ) {
              if (status === "OK") {
                if (results[0]) {
                  // @ts-ignore
                  self.address.formatted_address = results[0].formatted_address;
                }
              }
            });

            if (self.isIos() && localStorage.getItem("hideInstall") == null) {
              self.showIosPopup = true;
            }
          },
          function () {
            self.getRoutes();
            console.log("cannot get position");
            self.showLocationMessage();

           
            if (self.isIos() && localStorage.getItem("hideInstall") == null) {
              self.showIosPopup = true;
            }
          }
        );
      } else {
        console.log("browser no support man");
        localStorage.setItem("location", "0");
        self.showLocationPopup = false;

        self.showLocationMessage();

        self.getRoutes();
        if (self.isIos() && localStorage.getItem("hideInstall") == null) {
          self.showIosPopup = true;
        }
      }
    },
    denyLocation: function () {
      localStorage.setItem("location", "0");
      this.showLocationPopup = false;
      if (this.isIos() && localStorage.getItem("hideInstall") == null) {
        this.showIosPopup = true;
      }
    },
    async validRoute(routeId: string) {
      var existingCode = localStorage.getItem(routeId);
      if (existingCode !== null) {
        var errors = await RouteRepo.getRouteInfo(existingCode + "", routeId);
        console.log("errors");
        console.log(errors);
        if (errors !== "error") {
          var currentRoute = this.routes.find((f) => f.routeId == routeId);
          console.log(currentRoute);
          if (currentRoute != null) {
            currentRoute.activeUntil = errors;
          }
        }
      }
    },
    async openRoute(routeId: string) {
      var existingCode = localStorage.getItem(routeId);
      if (existingCode !== null) {
        var errors = await RouteRepo.unlockRoute(existingCode, routeId);

        if (errors.length === 0) {
          this.$router.push("/route/" + routeId);
        } else {
          this.$router.push("/route/" + routeId + "/unlock");
        }
      } else {
        this.$router.push("/route/" + routeId + "/unlock");
      }
    },
    getAddressData: async function (
      addressData: any,
      placeResultData: any,
      id: any
    ) {
      console.log("get address data");
      this.address = addressData;
      console.log(this.address);
      this.address.formatted_address =
        this.address.route +
        " " +
        (this.address.street_number || "") +
        ", " +
        this.address.locality;
      localStorage.setItem("address", JSON.stringify(this.address));
      this.searchAddress = false;
      await this.getRoutes();
    },
    editLocation() {
      this.searchAddress = true;
    },
    showLocationMessage() {
      var locationMessageDate = localStorage.getItem("enableLocationMessage");

      if (locationMessageDate != null) {
        var parsedDate = new Date(locationMessageDate);
        var now = new Date();

        parsedDate.setMinutes(parsedDate.getMinutes() + 30);
        if (now > parsedDate) {
          this.$swal({
            title: "Opgepast",
            html: this.locationMessage,
            icon: "error",
            confirmButtonText: "Sluiten",
            showCloseButton: true,
          });
        }
      }
      else {
          this.$swal({
            title: "Opgepast",
            html: this.locationMessage,
            icon: "error",
            confirmButtonText: "Sluiten",
            showCloseButton: true,
          });
      }

      localStorage.setItem("enableLocationMessage", JSON.stringify(new Date().toUTCString()));
    },
    redirectAppRoute: function (latitude: any, longitude: any) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          var redirectUrl = "https://www.google.com/maps/dir/?api=1";
          redirectUrl +=
            "&origin=" +
            position.coords.latitude +
            "," +
            position.coords.longitude;
          redirectUrl += "&destination=" + longitude + "," + latitude;
          redirectUrl += "&travelmode=walking";
          window.location.href = redirectUrl;
        },
        function () {
          var redirectUrl = "https://www.google.com/maps/dir/?api=1";
          redirectUrl += "&destination=" + longitude + "," + latitude;
          redirectUrl += "&travelmode=walking";

          window.location.href = redirectUrl;
        }
      );
    },
  },
  created: async function () {
    var self = this;
    try {
      var watchID = localStorage.getItem("watchId")
      navigator.geolocation.clearWatch(Number(watchID));

    } catch (exception) {
      console.log('error watchid' + exception);
    }
   

    console.log(localStorage.getItem("location"));
    if (localStorage.getItem("location") === null) {
      self.showLocationPopup = true;
    } else {
      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        console.log('geolocation');
        navigator.geolocation.getCurrentPosition(
          function (position) {
            console.log('get current position');
            localStorage.setItem("location", "1");
            self.showLocationPopup = false;
            console.log(position);
            // @ts-ignore
            self.address.longitude = position.coords.longitude;
            // @ts-ignore
            self.address.latitude = position.coords.latitude;
            self.getRoutes();
            // @ts-ignore
            var geocoder = new google.maps.Geocoder();
            // @ts-ignore
            var myLatlng = new google.maps.LatLng(parseFloat(position.coords.latitude), parseFloat(position.coords.longitude));
            geocoder.geocode({ location: myLatlng }, function (
              results: any,
              status: any
            ) {
              if (status === "OK") {
                if (results[0]) {
                  // @ts-ignore
                  self.address.formatted_address = results[0].formatted_address;
                }
              }
            });
          },
          function (error) {
                        console.log('error 1');

            console.log(error);
            self.getRoutes();
            console.log("cannot get position");
            

           
          },
          {
            timeout: 5000
          }
        );
      } else {
        console.log("browser no support man");
        localStorage.setItem("location", "0");

        self.showLocationPopup = false;
        // Browser doesn't support Geolocation
        self.showLocationMessage();

        self.getRoutes();
      }

      if (self.isIos() && localStorage.getItem("hideInstall") == null) {
        self.showIosPopup = true;
      }
    }

    if(localStorage.getItem("hideInstall") == null){
      window.addEventListener("beforeinstallprompt", function(e) {
        console.log('beforeinstallprompt');
        console.log(e);
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.

        self.deferredPrompt = e;
        setTimeout(function() {
          // @ts-ignore
          if (self.deferredPrompt && self.alreadyAccepted == false) {
            self.showInstallPopup = true;
            self.alreadyAccepted = true;
          }
        }, 5000);
      });  
    }

     

    console.log("mounted");
  },
  mounted: async function () {
    this.locationMessage = this.isIos()
      ? "We merken dat je locatie uitgeschakeld staat voor deze browserapp (Safari of Google). Ga naar je instellingen via <img style='width:40px' src='/img/settings-icon-ios.png'> en schakel voor deze browserapp de locatie detectie terug in."
      : "We merken dat je locatie uitgeschakeld staat voor deze browserapp. Controleer in je instellingen of deze browserapp en ook deze site toegang hebben om je locatie te gebruiken.";
  },
  watch: {},
  computed: {
    google: gmapApi,
  },
});
